var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76997 3.46687C7.66367 3.36266 7.66158 3.18966 7.76788 3.08337L8.75165 2.085H4.06206C3.91199 2.085 3.79111 1.96412 3.79111 1.81405C3.79111 1.66398 3.91199 1.5431 4.06206 1.5431H8.74957L7.7658 0.544734C7.66158 0.438437 7.66158 0.267527 7.76788 0.161229C7.87418 0.0570163 8.04509 0.0570164 8.15139 0.163314L9.58953 1.6223C9.61245 1.64731 9.6333 1.6744 9.6458 1.70775C9.66039 1.7411 9.66665 1.77653 9.66665 1.81197C9.66665 1.88283 9.63955 1.94953 9.58953 2.00163L8.15139 3.46062C8.04717 3.569 7.87626 3.57108 7.76997 3.46687ZM2.22999 6.34316C2.33629 6.23894 2.33837 6.06595 2.23208 5.95965L1.25039 4.96129H5.9379C6.08796 4.96129 6.20885 4.8404 6.20885 4.69033C6.20885 4.54027 6.08796 4.41938 5.9379 4.41938H1.25039L2.23416 3.42102C2.33837 3.31472 2.33837 3.14381 2.23208 3.03751C2.12578 2.9333 1.95487 2.9333 1.84857 3.0396L0.410431 4.49858C0.387504 4.52359 0.366661 4.55069 0.354156 4.58404C0.339566 4.61738 0.333313 4.65282 0.333313 4.68825C0.333313 4.75912 0.360408 4.82581 0.410431 4.87792L1.84857 6.3369C1.95279 6.44528 2.1237 6.44737 2.22999 6.34316Z",
    fill: "#F68121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.78cc474aa91a1a49b9a82d899d0d0de6.svg";
export { ForwardRef as ReactComponent };